import { CircleChevronsDown } from 'assets/icons/custom-lucide-icons/circle-chevrons-down-svg';

import { PoolCaC1 } from 'assets/icons/custom-lucide-icons/pool-ca-c1-svg';
import { PoolCaC3 } from 'assets/icons/custom-lucide-icons/pool-ca-c3-svg';
import { PoolCaC6 } from 'assets/icons/custom-lucide-icons/pool-ca-c6-svg';
import { PoolCaC7 } from 'assets/icons/custom-lucide-icons/pool-ca-c7-svg';
import { PoolCaC8 } from 'assets/icons/custom-lucide-icons/pool-ca-c8-svg';
import { PoolCaC10 } from 'assets/icons/custom-lucide-icons/pool-ca-c10-svg';
import { PoolCaC12 } from 'assets/icons/custom-lucide-icons/pool-ca-c12-svg';
import { PoolCaC14 } from 'assets/icons/custom-lucide-icons/pool-ca-c14-svg';
import { PoolCaC43 } from 'assets/icons/custom-lucide-icons/pool-ca-c43-svg';
import { PoolCaC44 } from 'assets/icons/custom-lucide-icons/pool-ca-c44-svg';
import { PoolCaC46 } from 'assets/icons/custom-lucide-icons/pool-ca-c46-svg';
import { PoolCaC50 } from 'assets/icons/custom-lucide-icons/pool-ca-c50-svg';
import { PoolCaC53 } from 'assets/icons/custom-lucide-icons/pool-ca-c53-svg';
import { PoolSmallBusiness } from 'assets/icons/custom-lucide-icons/pool-small-business-svg';
import { PoolSoftware } from 'assets/icons/custom-lucide-icons/pool-software-svg';
import {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDownCircle,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  Ban,
  Book,
  BookOpen,
  Box,
  Brain,
  BrainCircuit,
  Calculator,
  Calendar,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronUp,
  Circle,
  CircleChevronDown,
  Clock,
  Cloud,
  CloudOff,
  Columns,
  Compass,
  Copy,
  CornerUpLeft,
  CreditCard,
  DollarSign,
  Download,
  Edit2,
  ExternalLink,
  File,
  FileText,
  Filter,
  Folder,
  Gift,
  HelpCircle,
  History,
  Home,
  Info,
  Key,
  Landmark,
  LibraryBig,
  Link,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  Maximize2,
  Menu,
  Merge,
  MessageCircleQuestion,
  MessageSquare,
  Minimize2,
  Minus,
  MinusCircle,
  MinusSquare,
  MoreVertical,
  EllipsisVertical,
  Phone,
  Play,
  Plus,
  PlusCircle,
  Presentation,
  Printer,
  Receipt,
  RedoDot,
  RefreshCw,
  Repeat,
  RotateCcw,
  Save,
  Scale,
  Search,
  Send,
  Settings,
  Share,
  ShoppingCart,
  Slash,
  Square,
  SquareChartGantt,
  Trash2,
  TrendingDown,
  TrendingUp,
  Truck,
  Undo,
  Unlink2,
  Unplug,
  Upload,
  UploadCloud,
  User,
  UserMinus,
  UserPlus,
  Users,
  UserX,
  Wrench,
  X,
  XCircle,
} from 'lucide-angular';

export const icons = {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDownCircle,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  Ban,
  Book,
  BookOpen,
  Box,
  Brain,
  BrainCircuit,
  Calculator,
  Calendar,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronsLeft,
  ChevronRight,
  ChevronUp,
  ChevronsRight,
  Circle,
  CircleChevronDown,
  Clock,
  Columns,
  Compass,
  Copy,
  CornerUpLeft,
  CreditCard,
  Cloud,
  CloudOff,
  DollarSign,
  Download,
  Edit2,
  ExternalLink,
  File,
  FileText,
  Filter,
  Folder,
  Gift,
  History,
  Home,
  HelpCircle,
  Info,
  Key,
  Landmark,
  LibraryBig,
  Link,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  Maximize2,
  Menu,
  Merge,
  MessageCircleQuestion,
  MessageSquare,
  Minimize2,
  Minus,
  MinusCircle,
  MinusSquare,
  MoreVertical,
  EllipsisVertical,
  Phone,
  Play,
  Plus,
  PlusCircle,
  Presentation,
  Printer,
  Receipt,
  RedoDot,
  RefreshCw,
  Repeat,
  RotateCcw,
  Save,
  Scale,
  Search,
  Send,
  Settings,
  Share,
  ShoppingCart,
  Slash,
  Square,
  SquareChartGantt,
  Trash2,
  TrendingDown,
  TrendingUp,
  Truck,
  Undo,
  Unlink2,
  Unplug,
  Upload,
  UploadCloud,
  User,
  UserMinus,
  UserPlus,
  Users,
  UserX,
  X,
  XCircle,
  Wrench,
};

export const customIcons = {
  CircleChevronsDown,
  PoolCaC1,
  PoolCaC3,
  PoolCaC6,
  PoolCaC7,
  PoolCaC8,
  PoolCaC10,
  PoolCaC12,
  PoolCaC14,
  PoolCaC43,
  PoolCaC44,
  PoolCaC46,
  PoolCaC50,
  PoolCaC53,
  PoolSmallBusiness,
  PoolSoftware,
};
